import * as React from 'react';
import styled from 'styled-components';

import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Button,
	CircularProgress,
} from '../material-ui';

const StyledDialogContent = styled(DialogContent)`
	min-width: 25rem;
`;

const StyledDialogActions = styled(DialogActions)`
	padding: 0 1rem 1rem 0;
`;

const ProgressWrapper = styled.div`
	width: 100%;
	height: 100%;
	min-height: 15rem;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Alert = ({ title, description, loading, onAbort, onConfirm }) => (
	<Dialog open={Boolean(title || loading)} onClose={onAbort}>
		{title && <DialogTitle>{title}</DialogTitle>}
		<StyledDialogContent>
			{loading && (
				<ProgressWrapper>
					<CircularProgress />
				</ProgressWrapper>
			)}
			{description && (
				<DialogContentText>
					{description.split('\n').map((text) => (
						<span key={text}>
							{text} <br />
						</span>
					))}
				</DialogContentText>
			)}
		</StyledDialogContent>
		{(onAbort || onConfirm) && (
			<StyledDialogActions>
				{onAbort && <Button onClick={onAbort}>Abbrechen</Button>}
				{onConfirm && (
					<Button variant="contained" color="primary" onClick={onConfirm}>
						OK
					</Button>
				)}
			</StyledDialogActions>
		)}
	</Dialog>
);



// WEBPACK FOOTER //
// ./src/components/Alert.js